/**
 * 引导锚点在视口中的最小 top（px）：固定顶栏（Layout `.app-navbar`）底边以下 + 留白，
 * 避免滚过头后高亮与真实控件被顶栏盖住或与全局图标重叠。
 */
export function getCfdGuideViewportMinTopPx(): number {
  if (typeof document === "undefined") return 54;
  const nav = document.querySelector(".app-navbar") as HTMLElement | null;
  if (nav) {
    const bottom = nav.getBoundingClientRect().bottom;
    if (Number.isFinite(bottom) && bottom > 0) {
      const max = typeof window !== "undefined" ? window.innerHeight * 0.5 : 400;
      if (bottom < max) {
        return bottom + 4;
      }
    }
  }
  return 54;
}

/** 与 {@link getCfdGuideViewportMinTopPx} 联用：设计稿换算出的期望 top 不得低于顶栏安全区 */
export function clampGuideHighlightTopPx(desiredTopPx: number): number {
  return Math.max(desiredTopPx, getCfdGuideViewportMinTopPx());
}

/** 与标准版 Step4/7 一致：提示卡宽度与水平位置（避免靠右裁切） */
export function computeCfdGuideTipHorizontalLayout(
  anchor: { left: number; width: number },
  scale: number
): { tipLeft: number; lineCenterInTip: number; tipWidth: number } {
  const tipWidthDesign = 247 * scale;
  const vw = typeof window !== "undefined" ? window.innerWidth : 375;
  const pad = 16;
  const anchorCx = anchor.left + anchor.width / 2;
  const tipWidth = Math.min(tipWidthDesign, vw - 2 * pad);
  let tipLeft = anchorCx - tipWidth / 2;
  tipLeft = Math.max(pad, Math.min(tipLeft, vw - tipWidth - pad));
  const lineCenterInTip = anchorCx - tipLeft;
  return { tipLeft, lineCenterInTip, tipWidth };
}

export function getCfdGuideGapBelow(scale: number): number {
  return 58 * scale;
}
